export default __webpack_public_path__ + "static/media/tool-icon-shirt-black-16.c6d21f30.svg";